export default "__VITE_ASSET__75050930__"